/* eslint-disable no-undef, no-unused-vars, class-methods-use-this, prefer-destructuring   */
/**
 * Newsletter form handling class.
 *
 * @see template-parts/components/newsletter-form.php
 * @see lib/form/newsletter-form.php
 */
class NewsletterForm {
  constructor() {
    this.newsletterPopup = document.getElementById("newsletter-modal");
    if (this.newsletterPopup) {
      this.init();
    }
  }

  closePopup(evt) {
    evt.preventDefault();

    // Close popup
    evt.srcElement.closest("#newsletter-modal").classList.remove("active");

    // Enable scroll
    window.disableScroll.enableScroll();
  }

  init() {
    const newsletterPopupCloseButton = document.getElementById(
      "close-newsletter-modal"
    );

    // Close notificacion banner
    newsletterPopupCloseButton.addEventListener("click", this.closePopup);

    // Submit form
  }
}

export default NewsletterForm;
